import { render, staticRenderFns } from "./contact-info-missing.vue?vue&type=template&id=b6e8d2b0&scoped=true&"
import script from "./contact-info-missing.vue?vue&type=script&lang=js&"
export * from "./contact-info-missing.vue?vue&type=script&lang=js&"
import style0 from "./contact-info-missing.vue?vue&type=style&index=0&id=b6e8d2b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e8d2b0",
  null
  
)

export default component.exports